import { render, staticRenderFns } from "./VentanaBorrarUsuario.vue?vue&type=template&id=7c113f4b&scoped=true&slot-scope=scope&"
import script from "./VentanaBorrarUsuario.vue?vue&type=script&lang=js&"
export * from "./VentanaBorrarUsuario.vue?vue&type=script&lang=js&"
import style0 from "./VentanaBorrarUsuario.vue?vue&type=style&index=0&id=7c113f4b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c113f4b",
  null
  
)

export default component.exports